webpackJsonp([0],{

/***/ "QIjP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "demo" } }, [
    _c("div", { staticClass: "example-text" }, [
      _vm._v(
        "\n    Here is an example of a tooltip with absolute placement.\n  "
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "example" },
      [
        _c("tip", { attrs: { position: "auto-center" } }, [
          _c("div", { staticClass: "trigger" }, [_vm._v("Hover")]),
          _vm._v(" "),
          _c("span", { attrs: { slot: "tip" }, slot: "tip" }, [
            _vm._v("\n        Some additional content! "),
            _c("strong", [_vm._v("HTML")]),
            _vm._v(" can be "),
            _c("i", [_vm._v("used")]),
            _vm._v(" here..\n      ")
          ])
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "example-text" }, [
      _vm._v("\n    Here is an example of a tooltip with fixed placement.\n  ")
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "example" },
      [
        _c(
          "tip",
          { attrs: { fixed: true, position: "auto-center", width: 250 } },
          [
            _c("div", { staticClass: "trigger" }, [_vm._v("Hover")]),
            _vm._v(" "),
            _c("span", { attrs: { slot: "tip" }, slot: "tip" }, [
              _vm._v(
                "\n        I am fixed to the page. Useful when trying to display outside of a\n        container with complicated css scrolling or positioning.\n      "
              )
            ])
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "example-text" }, [
      _vm._v("\n    These tooltips use an auto position.\n  ")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "example-table" }, [
      _c("div", { staticClass: "example-row" }, [
        _c(
          "div",
          { staticClass: "example-cell" },
          [
            _c("tip", { attrs: { position: "auto-auto" } }, [
              _c("div", { staticClass: "trigger" }, [_vm._v("Hover")]),
              _vm._v(" "),
              _c("span", { attrs: { slot: "tip" }, slot: "tip" }, [
                _vm._v(
                  "\n            This tooltip is on the right.\n          "
                )
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "example-cell" },
          [
            _c("tip", { attrs: { position: "auto-auto" } }, [
              _c("div", { staticClass: "trigger" }, [_vm._v("Hover")]),
              _vm._v(" "),
              _c("span", { attrs: { slot: "tip" }, slot: "tip" }, [
                _vm._v(
                  "\n            This tooltip is in the center.\n          "
                )
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "example-cell" },
          [
            _c("tip", { attrs: { position: "auto-auto" } }, [
              _c("div", { staticClass: "trigger" }, [_vm._v("Hover")]),
              _vm._v(" "),
              _c("span", { attrs: { slot: "tip" }, slot: "tip" }, [
                _vm._v("\n            This tooltip is on the left.\n          ")
              ])
            ])
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-34adf496", esExports)
  }
}

/***/ }),

/***/ "Ri2j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    // tooltip position relative to trigger, supports the following:
    // 'auto-auto', 'auto-left', 'auto-center', 'auto-right',
    // 'top-auto', 'top-left', 'top-center', 'top-right',
    // 'bottom-auto', 'bottom-left', 'bottom-center', 'bottom-right'
    position: {
      type: String,
      default: 'auto-auto'
    },

    // width of the tooltip
    width: {
      type: Number,
      default: 150
    },

    // tooltip should be positioned using 'position: fixed' rather than
    // 'position: absolute' sometimes this is necessary when combining
    // relative/absolute/scrolling containers to bring the tooltip to the
    // front
    fixed: {
      type: Boolean,
      default: false
    },

    // tooltip offset x position
    offsetX: {
      type: Number,
      default: 0
    },

    // tooltip offset y position
    offsetY: {
      type: Number,
      default: 0
    }
  },

  data: function data() {
    return {
      // mouse coords
      x: 0,
      y: 0,
      // keep track of hovered state
      hovered: false,
      // keep track of touched state
      touched: false,
      // keep track of position 'auto' placements based on cursor position
      // when entering / exiting the trigger.
      autoVertical: null,
      autoHorizontal: null,
      // keep track of bounding rect for the trigger so that a identical
      // fixed wrapper can be used to anchor the tooltip to when fixed
      // positioning is used
      rect: null
    };
  },


  computed: {
    positionSplit: function positionSplit() {
      return this.position.split('-');
    },
    positionVertical: function positionVertical() {
      return this.positionSplit[0];
    },
    positionHorizontal: function positionHorizontal() {
      return this.positionSplit[1];
    },
    vertical: function vertical() {
      return this.positionVertical !== 'auto' ? this.positionVertical : this.autoVertical;
    },
    horizontal: function horizontal() {
      return this.positionHorizontal !== 'auto' ? this.positionHorizontal : this.autoHorizontal;
    },
    classes: function classes() {
      return ['vt', this.fixed ? 'vt-fixed' : null, this.vertical ? 'vt-' + this.vertical : null, this.horizontal ? 'vt-' + this.horizontal : null];
    },
    tipStyle: function tipStyle() {
      return {
        width: this.width + 'px'
      };
    },


    // position tooltip anchor accordingly
    anchorStyle: function anchorStyle() {
      if (this.rect && this.active) {
        if (this.fixed) {
          return {
            width: this.rect.width + 'px',
            height: this.rect.height + 'px',
            top: this.rect.top + this.offsetY + 'px',
            left: this.rect.left + this.offsetY + 'px',
            position: 'fixed'
          };
        } else {
          return {
            width: this.rect.width + 'px',
            height: this.rect.height + 'px',
            top: this.offsetY + 'px',
            left: this.offsetY + 'px',
            position: 'absolute'
          };
        }
      } else {
        return {
          display: 'none'
        };
      }
    },
    active: function active() {
      return this.hovered || this.touched;
    }
  },

  methods: {
    updateDimensions: function updateDimensions() {
      var touched = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.y > document.documentElement.clientHeight / 2 || touched) {
        this.autoVertical = 'top';
      } else {
        this.autoVertical = 'bottom';
      }

      if (this.x < document.documentElement.clientWidth * (1 / 3)) {
        this.autoHorizontal = 'right';
      } else if (this.x > document.documentElement.clientWidth * (2 / 3)) {
        this.autoHorizontal = 'left';
      } else {
        this.autoHorizontal = 'center';
      }

      this.rect = this.$refs.trigger.getBoundingClientRect();
    },
    mouseEnter: function mouseEnter(e) {
      this.x = e.clientX;
      this.y = e.clientY;
      this.updateDimensions();
      this.hovered = true;
    },
    mouseLeave: function mouseLeave() {
      this.hovered = false;
    },
    touchStart: function touchStart(e) {
      this.x = e.touches[0].clientX;
      this.y = e.touches[0].clientY;
      this.updateDimensions(true);
      this.touched = true;
    },
    touchEnd: function touchEnd() {
      this.touched = false;
    }
  }
});

/***/ }),

/***/ "S8VD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Demo_vue__ = __webpack_require__("gxQM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34adf496_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Demo_vue__ = __webpack_require__("QIjP");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("i6pJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-34adf496"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Demo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34adf496_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Demo_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "demo/Demo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Demo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-34adf496", Component.options)
  } else {
    hotAPI.reload("data-v-34adf496", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Sczw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tip_vue__ = __webpack_require__("Ri2j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc4ed894_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Tip_vue__ = __webpack_require__("eZIJ");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("rMVt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bc4ed894"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc4ed894_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Tip_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Tip.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Tip.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-bc4ed894", Component.options)
  } else {
    hotAPI.reload("data-v-bc4ed894", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "X+yM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eZIJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      class: _vm.classes,
      on: {
        mouseenter: _vm.mouseEnter,
        mouseleave: _vm.mouseLeave,
        touchstart: _vm.touchStart,
        touchend: _vm.touchEnd
      }
    },
    [
      _c(
        "span",
        { ref: "trigger", staticClass: "vt-trigger" },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "vt-tip-anchor", style: _vm.anchorStyle },
        [
          _c("transition", { attrs: { name: "vt-tip-fade" } }, [
            _vm.active
              ? _c("span", { staticClass: "vt-tip", style: _vm.tipStyle }, [
                  _c("span", { staticClass: "vt-content" }, [_vm._t("tip")], 2)
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("transition", { attrs: { name: "vt-arrow-fade" } }, [
            _vm.active ? _c("span", { staticClass: "vt-arrow" }) : _vm._e()
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-bc4ed894", esExports)
  }
}

/***/ }),

/***/ "gxQM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_index__ = __webpack_require__("lVK7");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Tip: __WEBPACK_IMPORTED_MODULE_0__src_index__["a" /* Tip */]
  }
});

/***/ }),

/***/ "i6pJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iXgl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Demo__ = __webpack_require__("S8VD");
// This file will build the demo

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<Demo/>',
  components: { Demo: __WEBPACK_IMPORTED_MODULE_1__Demo__["a" /* default */] }
});

/***/ }),

/***/ "lVK7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Tip__ = __webpack_require__("Sczw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_plugin_scss__ = __webpack_require__("X+yM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_plugin_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_plugin_scss__);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Tip__["a"]; });
// This file will build the plugin





/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__components_Tip__["a" /* default */]);



/***/ }),

/***/ "rMVt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["iXgl"]);


// WEBPACK FOOTER //
// static/js/app.c609851f6aba07b3ee19.js